import * as React from "react";
import { Chip, Box } from "@mui/material";
import {innerChipSx, outerChipSx} from "./styles";

export interface AlertSwitchProps {
    value: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
}

const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, onChange: (value: boolean) => void, value: boolean, disabled?: boolean,) => {
    if (disabled) {
        return;
    }
    e.stopPropagation();
    onChange(!value);
}

export function AlertSwitch({ value, onChange, disabled }: AlertSwitchProps) {
    return (
        <Chip
            clickable={!disabled}
            color={value ? "primary" : "error"}
            onClick={(e) => handleClick(e, onChange, value, disabled)}
            sx={outerChipSx}
            label={
                <Box display="flex" alignItems="center" gap={1}>
                    <Box sx={{ml:"auto", mr:"auto"}}>Alert</Box>
                    <Chip label={value ? "ON" : "OFF"} size="small" sx={innerChipSx(value)}/>
                </Box>
            }
        />
    );
}
